"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationAction = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../../molecules");

var _atoms = require("../../../atoms");

require("./NotificationAction.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic, Cameron Hassan
 */
var NotificationAction = function NotificationAction(_ref) {
  var _notification$deliver, _notification$message, _notification$message2, _notification$deliver2, _notification$deliver3, _notification$deliver4, _notification$message3, _notification$message4, _notification$message5, _notification$message6, _notification$message7, _notification$message8, _notification$message9, _notification$message10;

  var notification = _ref.notification,
      onActionClick = _ref.onActionClick;

  var _onClick = function onClick(e, action) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (typeof onActionClick === "function") {
      onActionClick(e, action, notification);
    }
  };

  var actionTaken = !!((_notification$deliver = notification.delivery) !== null && _notification$deliver !== void 0 && _notification$deliver.date_action);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((_notification$message = notification.message) === null || _notification$message === void 0 ? void 0 : (_notification$message2 = _notification$message.actions) === null || _notification$message2 === void 0 ? void 0 : _notification$message2.includes("traceid")) && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Notifications ".concat(!((_notification$deliver2 = notification.delivery) !== null && _notification$deliver2 !== void 0 && _notification$deliver2.date_action) ? "Save" : "View", " Pressed"),
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, !((_notification$deliver3 = notification.delivery) !== null && _notification$deliver3 !== void 0 && _notification$deliver3.date_action) && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.TraceIDEmpty
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: !actionTaken ? "Save" : "View",
      marginLeft: "2"
    })),
    primary: !((_notification$deliver4 = notification.delivery) !== null && _notification$deliver4 !== void 0 && _notification$deliver4.date_action),
    small: true,
    className: "notification-save-button",
    onClick: function onClick(e) {
      return _onClick(e, "traceid");
    }
  }), ((_notification$message3 = notification.message) === null || _notification$message3 === void 0 ? void 0 : (_notification$message4 = _notification$message3.actions) === null || _notification$message4 === void 0 ? void 0 : _notification$message4.includes("like")) && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Notifications Like",
    content: "Like",
    primary: true,
    small: true,
    disabled: actionTaken,
    marginTop: "2",
    onClick: function onClick(e) {
      return _onClick(e, "like");
    }
  }), ((_notification$message5 = notification.message) === null || _notification$message5 === void 0 ? void 0 : (_notification$message6 = _notification$message5.actions) === null || _notification$message6 === void 0 ? void 0 : _notification$message6.includes("who_watched")) && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Notifications Who Watched",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "Who Watched",
      marginLeft: "2"
    })),
    small: true,
    marginTop: "2",
    className: "notification-save-button",
    onClick: function onClick(e) {
      return _onClick(e, "who_watched");
    }
  }), ((_notification$message7 = notification.message) === null || _notification$message7 === void 0 ? void 0 : (_notification$message8 = _notification$message7.actions) === null || _notification$message8 === void 0 ? void 0 : _notification$message8.includes("go_to_leaderboard")) && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Notifications Go To Leaderboard",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.View
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "See Moment",
      marginLeft: "2"
    })),
    small: true,
    marginTop: "2",
    className: "notification-save-button",
    onClick: function onClick(e) {
      return _onClick(e, "go_to_leaderboard");
    }
  }), ((_notification$message9 = notification.message) === null || _notification$message9 === void 0 ? void 0 : (_notification$message10 = _notification$message9.actions) === null || _notification$message10 === void 0 ? void 0 : _notification$message10.includes("engagement_celebration")) && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Notifications Celebration",
    className: "".concat(actionTaken ? "notification-button-celebration-disabled" : "notification-button-content-grow"),
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "\uD83D\uDC4D",
      marginLeft: "2"
    })),
    small: true,
    border: actionTaken ? _atoms.Color.Grey4 : _atoms.Color.TraceTint2,
    borderColor: actionTaken ? _atoms.Color.Grey4 : _atoms.Color.TraceTint2,
    disabled: actionTaken,
    color: actionTaken ? _atoms.Color.Grey4 : _atoms.Color.TraceTint2,
    onClick: function onClick(e) {
      if (actionTaken) return;

      _onClick(e, "engagement_celebration");
    }
  }));
};

exports.NotificationAction = NotificationAction;